const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class TickerLinks extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.setupCarousel()
  }

  setupCarousel () {
    const animation = { duration: this.baseDuration, easing: (t) => t }
    const destination =
      this.getAttribute('data-direction') === 'forwards' ? -5 : 5
    let paused = false
    let pauseValue = 0

    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'performance',
        drag: true,
        slides: {
          perView: 'auto',
          gap: 0,
        },
        created (s) {
          s.moveToIdx(destination, true, animation)
        },
        updated (s) {
          if (!paused) {
            s.moveToIdx(s.track.details.abs + destination, true, animation)
          }
        },
        animationEnded (s) {
          if (!paused) {
            s.moveToIdx(s.track.details.abs + destination, true, animation)
          }
        },
      },
      [setInitialised()],
    )

    this.els.slides?.element?.addEventListener('mouseenter', () => {
      paused = true
      pauseValue = slider.animator.value
      slider.animator.stop()
    })

    this.els.slides?.element?.addEventListener('mouseleave', () => {
      paused = false
      const distanceRemaining = slider.track.details.max - pauseValue
      const pxPerMs = slider.track.details.max / this.baseDuration
      const remainingDuration = distanceRemaining / pxPerMs

      slider.moveToIdx(slider.track.details.abs + destination, true, {
        duration: remainingDuration,
        easing: (t) => t,
      })
    })

    return slider
  }

  get baseDuration () {
    return 50000
  }
}

if (!customElements.get('ticker-links')) {
  customElements.define('ticker-links', TickerLinks)
}
